import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Gem, Scissors, HeartHandshake, Sparkles } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { useContent } from "@/contexts/ContentContext";
import { useSettings } from "@/contexts/SettingsContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const ICONS = [HeartHandshake, Gem, Scissors, Sparkles];

export default function AboutPage() {
  const { t } = useLang();
  const { c } = useContent();
  const { img } = useSettings();
  const whyus = c("whyus", []);

  return (
    <div className="relative min-h-screen">
      <div className="vl-noise" />
      <Header />
      <section className="max-w-7xl mx-auto px-6 sm:px-8 pt-32 pb-16" data-testid="about-page">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden h-80 lg:h-[30rem]">
            <img src={img("store")} alt="" className="w-full h-full object-cover" />
          </div>
          <div>
            <div className="text-xs tracking-[0.35em] uppercase text-[var(--vl-gold)] mb-4">{t("nav_about")}</div>
            <h1 className="font-serif-display text-4xl sm:text-5xl font-light text-[var(--vl-ivory)] leading-tight">{c("about_title", t("about_title"))}</h1>
            <p className="text-base text-[var(--vl-stone)] mt-6 leading-relaxed font-light whitespace-pre-wrap">{c("about_text", t("about_text"))}</p>
            <div className="flex flex-wrap gap-4 mt-8">
              <Link to="/collecties" className="vl-btn-gold rounded-full px-7 py-3.5 text-sm tracking-widest uppercase font-medium inline-flex items-center gap-2">{t("discover_collection")} <ArrowRight size={15} /></Link>
              <Link to="/termin" className="vl-btn-outline rounded-full px-7 py-3.5 text-sm tracking-widest uppercase">{t("nav_appointment")}</Link>
            </div>
          </div>
        </div>
      </section>
      {whyus.length > 0 && (
        <section className="relative z-10 py-16 px-6 sm:px-8">
          <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {whyus.map((w, i) => { const Icon = ICONS[i % ICONS.length]; return (
              <div key={i} className="vl-card rounded-2xl p-7 text-center">
                <div className="mx-auto w-12 h-12 rounded-full border border-[var(--vl-gold)]/50 flex items-center justify-center mb-5"><Icon size={22} className="text-[var(--vl-gold)]" /></div>
                <h3 className="font-serif-display text-xl text-[var(--vl-ivory)]">{w.title}</h3>
                <p className="text-sm text-[var(--vl-stone)] mt-2 leading-relaxed">{w.text}</p>
              </div>
            ); })}
          </div>
        </section>
      )}
      <Footer />
    </div>
  );
}
